<template>
    <div>
        <h1 class="text-3xl sm:text-4xl md:text-6xl mb-16 sm:mb-32">Letzte Ankündigungen</h1>

        <p class="text-subtext-color font-heading text-lg leading-spaced w-full mb-24">
            Damit du stets alle wichtigen Änderungen und alle neuen Funktionen im Blick hast, listen wir hier alle Änderungen auf, sobald diese zur Verfügung stehen.
        </p>

        <header-toolbar>
            <chip :color="activePriority === 3 ? 'error' : 'gray-100'" clickable :value="activePriority === 3" @click="toggleActivePriority(3)" class="mr-4">Wichtige Änderungen</chip>
            <chip :color="activePriority === 2 ? 'success' : 'gray-100'" clickable :value="activePriority === 2" @click="toggleActivePriority(2)" class="mr-4">Mittlere Änderungen</chip>
            <chip :color="activePriority === 1 ? 'success' : 'gray-100'" clickable :value="activePriority === 1" @click="toggleActivePriority(1)" class="mr-4">Kleine Änderungen</chip>
        </header-toolbar>

		<data-loader :url="'/v1/changelog'" :params="params" :filter="filter"
					 :persist-filter-keys="['priority']"
					 scroll class="mt-16">
			<template v-slot="{data}">
				<template v-for="(item, itemKey) in data">
					<changelog-item :item="item"/>
					<divider v-if="itemKey < data.length - 1"/>
				</template>
			</template>

			<template #loading>
				<loader min-height="200"/>
			</template>
		</data-loader>
    </div>
</template>

<script setup lang="ts">
import {useIndexStore} from "../../../store";

const indexStore = useIndexStore();

const activePriority = ref(null);

const params = {
	type: indexStore.area.id >= 3 ? 3 : indexStore.area.id
}

const filter = computed(() => {
	return {
		priority: activePriority.value ? activePriority.value : undefined
	};
});

function toggleActivePriority(value) {
	activePriority.value = activePriority.value === value ? null : value;
}

useMeta({
	title: 'Letzte Ankündigungen',
	description: `Durchsuche die aktuellen Ankündigungen auf ${indexStore.area.title}.`
})

</script>
